import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, ArrowRight } from 'lucide-react';
import CoursesPageHeader from './CoursesPageHeader';
import Footer from './Footer';
import './Courses.css';

function Courses() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="courses-page">
      <CoursesPageHeader />

      <div className="courses-container">
        <section className="courses-hero">
          <div className="courses-hero-badge">
            <GraduationCap size={18} />
            Обучение
          </div>
          <h1>Курсы по нейросетям</h1>
          <p className="courses-hero-subtitle">
            Научитесь создавать контент с помощью AI.
          </p>
        </section>

        <section className="courses-list-empty">
          <p>Скоро здесь появится список курсов. А пока вы можете оставить заявку — мы сообщим о старте и подберём программу под ваши задачи.</p>
          <Link to="/courses/form" className="courses-submit-btn courses-list-cta">
            Оставить заявку
            <ArrowRight size={18} />
          </Link>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default Courses;
